module.exports = __webpack_public_path__ + "img/infant.18f98024.svg";